  <footer class="footer" [ngClass]="{'dark-mode': isDarkMode}" >
    <div class="footer-content">
      <p class="copyright">© {{currenYear}} CenterPoint Energy</p>
      <!--<div class="footer-links">
        <button class="footer-link" tabindex="0">Terms</button>
        <div class="divider"></div>
        <button class="footer-link" tabindex="0">Legal</button>
      </div>-->
    </div>
  </footer>
